import { PlaceholdersId, TFComponent } from '@types';
import { CloudwareDocumentPlaceholder } from './cloudwareDocument';

export const cloudwareDocument: TFComponent = {
	component: CloudwareDocumentPlaceholder,
	id: PlaceholdersId.cloudwareDocument,
	name: 'cloudwareDocument',
};
